import { api } from 'API/axios';
import { SEARCH_RESULTS_TYPE, SORT_BY, STATUSES } from 'Enum/SearchResults';
import { lettersOrNumbersRegex } from 'Regex';
import { addImposterToUrl } from 'Utils';

export interface ISearchSuggestion {
  suggestionText: string;
  typeSuggestionText: string;
  indexType: number;
}

export interface ISearchResult {
  requestNumber: number;
  isActive: boolean;
  linkedApplyNumbers: number[];
  subject: string;
  updateDate: Date;
  isDownload: boolean;
  type: SEARCH_RESULTS_TYPE;
  identifier: string;
  description: string;
  relativeLinkUrl?: string;
  itemData?: {};
  id: number;
  statusDescription?: string;
  medRefStatus?: STATUSES;
  subSubject?: string;
  shemeshApplyNumber?: number;
  displayDate?: Date;
  benefitGroupCode?: number;
  statusCode?: number;
  semanticRerankerScore: number;
  rerankerBoostedScore: number;
  appMaanakSum?: number;
  userNote?: string;
  reply?: string;
  name?: string;
  url?: string;
  duty?: string;
  workPhone1?: string;
  workPhone2?: string;
  fax?: string;
  email?: string;
  lastDateTimeUsed?: Date;
  categoryName?: string;
  documentName?: string;
  subjectName?: string;
  fileDate?: Date;
  typeId?: number;
  month?: number;
  year?: number;
  payslipId?: number;
  accessiblePayslipId?: number;
  beginDateEntitlement?: Date;
  endDateEntitlement?: Date;
  entitlementDays?: number;
  daysBalance?: number;
  accompanied?: number;
  statusLabel?: string;
  supplierName?: string;
  hotelName?: string;
  orderNumberSupplier?: string;
  startDate?: Date;
  daysNumber?: number;
  accompaniedNumber?: number;
  statusDate?: Date;
  status?: number;
  medicationName?: string;
  nextRefreshDate?: Date;
  originalOrderId?: number | null;
  prescCode?: number | null;
  isManual?: boolean;
  medicationNames?: string[];
  currentStatus?: number;
  currentStatusLabel?: string;
  itemName?: string;
  lastOrderOfThatItem?: Date;
  createDate?: Date;
  pgimaNumber?: string;
  contact?: string;
  internetReqNum?: number;
  validToDate?: Date;
  validFromDate?: Date;
}

export interface ISearchParams {
  pageSize?: number;
  pageNumber?: number;
  id?: number;
  utcFromDate?: string;
  utcToDate?: string;
  type?: SEARCH_RESULTS_TYPE[];
  sortBy?: SORT_BY;
}

export interface ISearchResponse {
  results: ISearchResult[];
  totalCount: number;
  promptResult: string;
}

const baseURL = '/SearchResults';
const MIN_SEARCH_QUERY_LENGTH = 2;

const sanitizeQuery = (query: string): string => {
  return query.replace(lettersOrNumbersRegex, '');
};

export const getSearchResults = async (searchValue: string) => {
  const sanitizedValue = sanitizeQuery(searchValue);
  if (sanitizedValue.length === 0) return;

  const result = await api.get<ISearchResponse>(
    addImposterToUrl(
      `${baseURL}?query=${encodeURIComponent(sanitizedValue)}`,
      false
    )
  );
  if (result) return result.data;
};

export const getSearchSuggestions = async (
  query: string
): Promise<ISearchSuggestion[] | undefined> => {
  const sanitizedQuery = sanitizeQuery(query);
  if (sanitizedQuery.length < MIN_SEARCH_QUERY_LENGTH) return;

  const result = await api.get<ISearchSuggestion[]>(
    addImposterToUrl(
      `${baseURL}/suggestions?query=${encodeURIComponent(sanitizedQuery)}`,
      false
    )
  );
  if (result) return result.data;
};
